import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import appConfig from '../appConfig';
import httpService from '@/utils/httpService';

import "vue-swatches/dist/vue-swatches.css";

import './styles/freshworks.css'
// Design System - Global tokens and component patterns
import './styles/_design-tokens.scss'
import './styles/_component-patterns.scss'
import './features/ReleaseNotes/styles/release-body.scss'

import "@/extensions/mainExtension";
import "@/extensions/TouchSelectionExtension";
import "@/extensions/MeasurementExtension";
import "@/extensions/Cropping2DExtension";
import "@/extensions/Cropping3DExtension";
import "@/extensions/PointCloudEraserExtension";
import "@/extensions/ScaffoldBoxExtension";
import "@/extensions/CustomContextMenuExtension";
import "@/extensions/mapping2d_3dExtension";
import "@/extensions/CameraTweenTool";
import "@/extensions/Plan2DExtension";
import "@/extensions/WalkingPathExt";
import "@/extensions/labels3dExt";

import "@/fonts/Artifakt_Regular";
import "@/fonts/Artefact_Bold";
import "@Share/config/filter.js";
import "@Share/config/directives.js";

import vuetify from "./plugins/vuetify";
import VuetifyDialog from "vuetify-dialog";
import "vuetify-dialog/dist/vuetify-dialog.css";
import "./plugins/slideout";
import signalR from "./plugins/signalR";
import VTiptap from "@peepi/vuetify-tiptap";
import priorityImageLoader from "@/plugins/priority-images";
import downloadManagerPlugin from "@/plugins/downloadManager";
import Mixins from "@/features/Share/config/mixins";
import VueApexCharts from 'vue-apexcharts';
Vue.use(VueApexCharts);

Vue.component('apex-charts', VueApexCharts);

import EnvizionLoader from '@/components/common/EnvizionLoader.vue';
Vue.component('envizion-loader', EnvizionLoader);

Vue.mixin(Mixins);

Vue.use(priorityImageLoader)
Vue.use(downloadManagerPlugin)
Vue.use(VTiptap);
Vue.use(signalR);
Vue.use(VuetifyDialog, {
  context: {
    vuetify,
  },
});
Vue.config.productionTip = false;

// Dev-only AI analysis mock (AVA-531): the chunk is only requested when the flag reads 'enabled',
// so every other build keeps its network calls byte-identical.
const mountApp = () =>
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");

if (appConfig.aiInspectMock === 'enabled') {
  // Mount only after the interceptor is installed, so no early request (e.g. a dashboard hook's
  // processingCount call) slips through to the real API before the mock is in place.
  import(/* webpackChunkName: "ai-inspect-mock" */ '@/features/Dashboard/mocks/aiInspectMock')
    .then(({ installAiInspectMock }) => {
      installAiInspectMock(httpService, { store });
    })
    .catch((err) => {
      console.error('[aiInspectMock] failed to load the dev mock chunk — AI endpoints will hit the real API', err);
    })
    .finally(mountApp);
} else {
  mountApp();
}
